import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"more\"><style>#more .st0{display:none}</style><path class=\"st0\" d=\"M0 0h16v16H0z\" /><g id=\"more_编组-8\" transform=\"translate(1765 453)\"><path id=\"more_Shape\" d=\"M-1763.2-445.7h10.4l-3.9-3.3c-.3-.3-.3-.7 0-1 .3-.3.8-.3 1.1 0l5.3 4.5c.2.1.2.3.2.5s-.1.4-.2.5l-5.4 4.6c-.2.1-.4.2-.6.2-.2 0-.4-.1-.6-.2-.3-.3-.3-.7 0-1l3.9-3.3h-10.4c-.4 0-.8-.3-.8-.7.2-.5.6-.8 1-.8z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/more.svg
// module id = 3/hf
// module chunks = 6